// The backend stores the literal 'none_images' when a row has no image (see the root repo's docs/context/13-glossary.md).
// Callers treat '' as "no image" and skip the <img>.
export const NO_IMAGE_SENTINEL = 'none_images';
export const handleImageUrl = (url:string) => {
    if (!url || url === NO_IMAGE_SENTINEL) return '';
    if (/^https?:\/\//i.test(url)) return url;
    const base = (process.env.REACT_APP_LOCAL_API || '/').replace(/\/$/, '');
    const prefix = (process.env.REACT_APP_UPLOADS_PATH_PREFIX ?? 'public').replace(/^\/+|\/+$/g, '');
    const path = String(url).replace(/^\//, '');
    return prefix ? `${base}/${prefix}/${path}` : `${base}/${path}`;
}
export const handleDateFormat = (date: Date) => {
    let day = date.getDate()
    let month = date.getMonth() + 1
    return `${day.toString().length === 1 ? `0${day}`: day}.${month.toString().length === 1 ? `0${month}` : month}.${date.getFullYear()}`
}
export const handleDateMinMax = (dates: string) => {
    if(Object.keys(JSON.parse(dates)).length === 0){
        return false
    }
    let datesArr = Object.keys(JSON.parse(dates)).map((key) => [key, JSON.parse(dates)[key]]);
    let minDate = new Date(datesArr[0][1]?.startDate)
    let maxDate = new Date(datesArr[datesArr.length - 1][1].endDate)
    return `${handleDateFormat(minDate)} - ${handleDateFormat(maxDate)}`
}
export const handleAvailableDatesFormat = (dates: any) => {
    try {
        if (!dates || dates === '{}' || dates === '') {
            return [];
        }
        const parsed = typeof dates === 'string' ? JSON.parse(dates) : dates;
        if (!parsed || typeof parsed !== 'object') {
            return [];
        }
        let dateArr = Object.keys(parsed).map((key) => [key, parsed[key]]);
        return dateArr.map(e => {
            return {
                start: new Date(e[1].startDate),
                end: new Date(e[1].endDate),
            }
        })
    } catch (error) {
        console.error('Error parsing available dates:', error);
        return [];
    }
}
export const allDaysOfRange = (dateRanges:any) => {
    const allDays = [];

    for (const dateRange of dateRanges) {
        const startDate = new Date(dateRange.start);
        const endDate = new Date(dateRange.end);

        const currentDate = new Date(startDate);
        while (currentDate <= endDate) {
            allDays.push(new Date(currentDate).getTime());
            currentDate.setDate(currentDate.getDate() + 1);
        }
    }

    return allDays;
}

// Make a URL-friendly slug from a string (basic transliteration and cleanup)
export const slugify = (text = '') => {
    return text
        .toString()
        .normalize('NFKD') // split accented characters
        .replace(/[\u0300-\u036f]/g, '') // remove diacritics
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // remove non-alphanum chars
        .trim()
        .replace(/\s+/g, '-') // spaces to dashes
        .replace(/-+/g, '-'); // collapse repeated dashes
}